import React, { useState, useEffect } from "react";
// import QrReader from "react-qr-reader";
import Input from "../common/inputfunction";
import { getItem } from "../../services/fire";
import FontAwesome from "react-fontawesome";

const Qrscan = () => {
  const [qrcodeid, setresult] = useState("");
  const [Scan, setScan] = useState(true);
  const [searchname, setsearhname] = useState("");
  const [gropname, setgropname] = useState("");
  const [areaname, setareaname] = useState("");
  const [itemlist, setitemlist] = useState([]);
  const handleError = (err) => {};
  const handleChange = () => {};
  const handleQRChange = (event) => {
    setresult(event.currentTarget.value);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setsearhname(qrcodeid);
    }
  };

  const handleOnClick = () => {
    setScan(!Scan)

  };
  const handleSearchClick = () => {
    setsearhname(qrcodeid);
  };

  useEffect(() => {
    if (!searchname) return;
    const loadData = async () => {
      const { data: result } = await getItem(searchname);
      if (result) {
        setitemlist(result);
      }
    };
    loadData();
  }, [searchname]);

 // console.log(itemlist);

  const handleScan = (data) => {
    if (data && data !== null) {
      play();
      setScan(false);
      setresult(data);
      setsearhname(data);
    }
  };
  function play() {
    var beepsound = new Audio(
      "https://www.soundjay.com/button/sounds/beep-01a.mp3"
    );
    beepsound.play();
  }
  useEffect(() => {
    if (itemlist && itemlist.length > 0) {
      const loadData = async () => {
        if (itemlist && itemlist.length) {
          setareaname(itemlist[0].Location_name);
          setgropname(itemlist[0].Equipment_name);
        } else {
          setareaname("");
          setgropname("");
        }
      };
      loadData();
    } else {
      setareaname("");
      setgropname("");
    }
  }, [itemlist]);

  return (
    <>

<div className="col-sm-6 m-2">
        {/* {Scan && (
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: "100%" }}
          />
        )} */}
        <p>{qrcodeid}</p>
      </div>

      <div className="col-sm-6">
        <div className="row">
          <Input
            name="qrcode"
            id="qrcode"
            value={qrcodeid}
            onChange={handleQRChange}
            onKeyPress={handleKeyPress}
            onClick={handleSearchClick}
            search={"ค้นหา"}
          />
          <div className="mt-4 ml-3">
            { Scan ? <button
              className="btn btn-secondary btn-sm"
              onClick={() => handleOnClick()}
            >
              <FontAwesome name="camera" />
            </button>:<button
              className="btn btn-danger btn-sm"
              onClick={() => handleOnClick()}
            >
              <FontAwesome name="camera" />
            </button>
            
            
            }
          </div>
        </div>
      </div>

       { gropname && <div className="row">
        <div className="col-sm-6">
          <Input
            name="gropname"
            id="gropname"
            value={gropname}
            onChange={handleChange}
          />
        </div>

        <div className="col-sm-6">
          <Input
            name="areaname"
            id="areaname"
            value={areaname}
            onChange={handleChange}
          />
        </div>
      </div>}

     
    </>
  );
};

export default Qrscan;
